import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ViewCommentsComponent } from 'src/app/core/check/view-comments/view-comments.component'
import { UpdateCriteriaComponent } from 'src/app/core/check/update-criteria/update-criteria.component'
import { UpdateKpiComponent } from 'src/app/core/check/update-kpi/update-kpi.component';
import { Chart, ChartData, ChartDataset, ChartOptions, ChartType } from 'chart.js';
import { ControlPointService } from 'src/app/services/control-point.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AetStateService } from 'src/app/services/aet-state.service'
import { Constants } from 'src/app/constants';
import { Router } from '@angular/router';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as FileSaver from 'file-saver-es';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import {
  debounceTime,
  fromEvent,
  map,
  mapTo,
  ReplaySubject,
  shareReplay,
  startWith,
  switchMap,
  timer,
} from 'rxjs';

@Component({
  selector: 'app-control-point-matrix',
  templateUrl: './control-point-matrix.component.html',
  styleUrls: ['./control-point-matrix.component.scss'],
  standalone: false // NOSONAR
})
export class ControlPointMatrixComponent implements OnInit {
  private intervalSubscription: Subscription;
  successMessage: any;
  chart: Chart;
  selectedTab: any
  snapshotDate: any = new Date();
  shapShotId: any
  defaultColDef: any;
  gridApi1: any;
  gridApi2: any;
  icons: any;
  context: any;
  isRowSelectable: any;
  rowSelection: any;
  columnDef: any;
  trailerColumnDefs: any;
  displayRowData: any;
  highlightUnVerified: any = false
  highlightVerified: any = false
  highlightTrailer: any = false
  unloadDate: any;
  route: any;
  errorMessage: any;
  gridOptions: any;
  siteItems: any;
  selected_position_id: any = 60000;
  snapShotList: any = [];
  thresholdList: any = [];
  displayCurrentData: any = [];
  //my variable changes
  planName: any = '01TMK'
  plantList: any
  domiciles: any
  lpDate: any = new Date()
  pastDate: any = new Date(); // Create a new date object
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  test = new Date(this.lpDate.getFullYear() - 5, this.lpDate.getMonth(), this.lpDate.getDate());
  minDate = this.test.toISOString().split('T')[0]; constTrailers = 'Contingent Trailers In Use'
  constContg = 'Contingent Trailers Available'; constTotalContg = 'Total Contingent Trailers'; constYard = 'Yard Parking Capacity'; const_plnd = 'Planned Missed Unload'
  constRoutes = 'Actual Routes Missed Unload'; constExpd = 'Expedites Not Covered'; constExpd_covr = 'Expedites Covered'; constNamc = 'NAMC Expedites'
  const_drpd = 'Dropped Routes Not Covered'; const_drpd_rout = 'Dropped Routes'; const_act_drpd = 'Actual Dropped Routes'; const_supp = 'Suppliers Closed'
  selectedDomiciles: any = [
    { id: 'suppliersClosed', description: this.const_supp },
    { id: 'actualDroppedRoutes', description: this.const_act_drpd },
    { id: 'droppedRoutes', description: this.const_drpd_rout },
    { id: 'droppedRoutesNotCovered', description: this.const_drpd },
    { id: 'namcExpedites', description: this.constNamc },
    { id: 'recoveryExpedites', description: this.constExpd_covr },
    { id: 'expeditesNotCovered', description: this.constExpd },
    { id: 'routesMissedUnload', description: this.constRoutes },
    { id: 'plannedMissedUnload', description: this.const_plnd },
    { id: 'ydParkingCapacity', description: this.constYard },
    { id: 'parkingOccupied', description: 'Parking Occupied' },
    { id: 'parkingAvailable', description: 'Parking Available' },
    { id: 'cntgntTrailers', description: this.constTotalContg },
    { id: 'cntgntTrailersInUse', description: this.constTrailers },
    { id: 'cntgntTrailersAvailable', description: this.constContg },
    { id: 'absenteeism', description: 'Absenteeism' },
    { id: 'misconnects', description: 'Misconnects' },
    { id: 'totalBlowout', description: 'Blowout' },
    { id: 'totalShortage', description: 'Shortage' },
    { id: 'totalLateRoute', description: 'Late Routes' },
    { id: 'totalPreemptive', description: 'Preemptive' }
  ]
  optionalDomiciles: any = []
  fileredWithPlant: any
  fileredWithKpi: any
  cpmthrosholdList: any;
  cpmStatsList: any;
  hideGraph: boolean = false;
  domicileFilterCtrl: FormControl = new FormControl();
  filteredDomiciles: ReplaySubject<any[]> = new ReplaySubject(1);
  brdClr1 = 'rgba(247, 82, 82,1)'; brdClr2 = 'rgba(250, 195, 57,1)'; brdClr3 = 'rgba(138, 235, 144,0.8)'; brdClr4 = 'rgba(138, 235, 144,1)'; brd_clr_5 = 'rgba(138, 235, 144, 0.4)'
  public lineChartColors = [
    { // Series A
      backgroundColor: this.brd_clr_5,
      borderColor: this.brdClr4,
      pointBackgroundColor: this.brdClr4,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: this.brdClr3
    },
    { // Series A
      backgroundColor: 'rgba(250, 236, 60, 0.2)',
      borderColor: 'rgba(250, 236, 60,1)',
      pointBackgroundColor: 'rgba(250, 236, 60,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(250, 236, 60,0.8)'
    },
    { // Series B
      backgroundColor: 'rgba(250, 195, 57,0.2)',
      borderColor: this.brdClr2,
      pointBackgroundColor: this.brdClr2,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: this.brdClr2
    },
    { // Series B
      backgroundColor: 'rgba(247, 82, 82,0.2)',
      borderColor: this.brdClr1,
      pointBackgroundColor: this.brdClr1,
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: this.brdClr1
    }
  ];

  autoPress: boolean = false;

  public lineChartLegend = true;

  public lineChartType: ChartType = 'line';

  // public lineChartOptions: ChartOptions = {
  //   responsive: true,
  //   maintainAspectRatio: false,
  //   plugins: {
  //     legend: { // ✅ Ensure legend is inside `plugins`
  //       display: true, // ✅ This enables the legend
  //       position: 'top', // Adjust position as needed: 'top', 'bottom', 'left', 'right'
  //       labels: {
  //         usePointStyle: true, // ✅ Makes legend items circular
  //       },
  //     },
  //   },
  // };

  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'nearest',
      intersect: false,
    },
    plugins: {
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || '';
            const value = context.raw;
            return `${label}: ${value}`;
          }
        }
      },
      legend: {
        position: 'top',
        labels: {
          usePointStyle: true
        }
      }
    },
    scales: {
      x: {
        ticks: {
          maxRotation: 40,
          minRotation: 0,
          color: 'rgba(0,0,0,1)'
        },
        grid: {
          drawOnChartArea: true
        }
      },
      y: {
        suggestedMin: -1,
        suggestedMax: 1,
        ticks: {

        },
        grid: {
          drawOnChartArea: true
        }
      }
    }
  };



  public lineChartLabels: string[] = [];

  public lineChartData: ChartData = {
    labels: [],
    datasets: [],
  };

  cpmStatData: any;
  plantValues: any;
  isAccessible = true;
  rowClassRules: any;
  rowHeight = 30;
  gridApi: any;
  currentPageNo: number = 1;
  currentPageBoolean: boolean = false;
  totalPage: number = 0;
  currentPageForTotalPage!: number;
  isLastPageFound!: boolean;
  paginationPageSize: any = 10;
  rowCount: number = 0;
  rowCountHistory: number = 0;
  isLastPageFoundHistory: boolean;
  paginationPageSizeHistory: any = 10;
  totalPageHistory: number;
  currentPageForTotalPageHistory: number;
  currentPageNoHistory: number;
  currentPageBooleanHistory: boolean;
  gridArray: any;
  statPlantList: any;
  defaultDisplayRowData: any;
  const_brdrclr = 'rgba(38, 136, 218,1)'
  constructor(public dialog: MatDialog, private readonly service: ControlPointService, private readonly aetStateService: AetStateService,
    private readonly DatePipe: DatePipe, private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly constants: Constants, public cdr: ChangeDetectorRef,
    private readonly router: Router) {
    this.context = {
      componentParent: this
    };
    this.rowClassRules = {
      'row-even': 'node.rowIndex % 2 == 0',  // NOSONAR
      'row-odd': 'node.rowIndex % 2 != 0',             // NOSONAR
    };
  }
  searchCtrl = new FormControl('');
  ngOnInit() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.service.loadDomiciles().subscribe((response) => {
      this.plantList = []
      if (response) {
        JSON.parse(JSON.stringify(response)).forEach(element => {
          if (!element.itemDesc.includes('PDC')) { this.plantList.push({ description: element.itemDesc, position: element.itemCode }) }

        })
      }

      this.plantList.sort((a, b) => {
        const valueA = a.description?.toLowerCase() ?? '';
        const valueB = b.description?.toLowerCase() ?? '';

        if (valueA < valueB) {
          return -1;
        }

        if (valueA > valueB) {
          return 1;
        }

        return 0;
      });
      this.GetcolumnDef();
    })
    // this.checkRoles();


    this.selectedDomiciles.sort((a, b) => {
      const valueA = a.description?.toLowerCase() ?? '';
      const valueB = b.description?.toLowerCase() ?? '';

      if (valueA < valueB) {
        return -1;
      }

      if (valueA > valueB) {
        return 1;
      }

      return 0;
    });


    this.filteredDomiciles.next(this.selectedDomiciles?.slice());
    this.siteItems = [
      { position: '60000', description: '1 min' },
      { position: '120000', description: '2 min' },
      { position: '300000', description: '5 min' },
      { position: '600000', description: '10 min' },
    ];
    this.defaultDisplayRowData = [
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
      { rowHeader: '' },
    ];
    this.icons = {
      sortUnSort: '<img src="assets/images/Icon awesome-sort.svg">',
    };
    this.selectedTab = 'current'
    this.highlightUnVerified = true;
    this.fetchCPMDashboardData();
    this.pastDate.setDate(this.lpDate.getDate() - 7);

    this.domicileFilterCtrl.valueChanges
      .pipe(
        startWith(''),
        map(search => search ? this.filterOption(search, this.selectedDomiciles) : this.selectedDomiciles?.slice())
      )
      .subscribe(filtered => {
        this.filteredDomiciles.next(filtered);
      });
  }
  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return list.filter(d => d.description.toLowerCase().includes(filterValue));
  }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length;  // NOSONAR
  }

  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }


  toggleSelectAll(event: MatCheckboxChange, selectedKey: string, allOptions: any[]): void {
    if (event.checked) {
      this[selectedKey] = [...allOptions]; // ✅ CORRECT
    } else {
      this[selectedKey] = [];
    }
    this.cdr.detectChanges(); // Optional
    this.onDomicileChange()
  }

  // async checkRoles() {
  //   await this.aetStateService.getRoles();
  //   const roles = this.aetStateService.getroleState();
  //   const userRoles = JSON.parse(roles);
  //   // this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  //   if (userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_MTM_Planner) ||
  //     userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner))) {
  //     this.isAccessible = true;

  //   }
  //   else {
  //     this.router.navigate([`/home`]);
  //   }
  //   // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
  //   //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
  //   //   // this.isAccessible = true;
  //   // } else {
  //   //   this.router.navigate([`/home`]);
  //   // }
  // }

  callingStatsFunctionality() {
    if (!this.cpmStatsList || !Array.isArray(this.cpmStatsList)) {
      return;
    }

    const date = new Date(this.lpDate);
    let value = '';
    date.setHours(0, 0, 0, 0);
    const labels = [];

    for (let i = 0; i < this.cpmStatsList.length; i++) {
      value = moment(this.cpmStatsList[i].snapshotTime).format('MM/DD/YY HH:mm');
      labels.push(value);
      date.setDate(date.getDate() + 1);
    }
    this.lineChartLabels = labels.slice(0, this.cpmStatsList.length);

  }


  onDomicileChange() {
    this.optionalDomiciles = this.optionalDomiciles.filter(e => e)

    this.callingStatsFunctionality()
    const kpiIds = this.optionalDomiciles?.map(item => item.id)
    if (kpiIds.length == 1) {  // NOSONAR
      this.hideGraph = false;
      this.lineChartData = {
        labels: [],
        datasets: [],
      };
      this.fileredWithKpi = []
      let normalLimit, badLimit, concernLimit, fairLimit;
      this.fileredWithPlant = this.cpmthrosholdList?.filter(product => product.logisticsPoint == this.planName)  // NOSONAR
      const graphData = this.cpmStatsList?.map(item => item[kpiIds.join('')])
      this.fileredWithKpi.push(this.fileredWithPlant?.filter(set => set.kpiCode == kpiIds.join('')))  // NOSONAR
      const maxRange = this.cpmStatsList?.reduce((max, obj) => obj[kpiIds.join('')] > max ? obj[kpiIds.join('')] : max, 0)
      if (kpiIds.join('') == 'parkingAvailable' || kpiIds.join('') == 'cntgntTrailersAvailable') {  // NOSONAR
        this.callingLineChartColorsforParking()
        concernLimit = Array(this.cpmStatsList?.length).fill(this.fileredWithKpi[0][0]?.concern)
        fairLimit = Array(this.cpmStatsList?.length).fill(this.fileredWithKpi[0][0]?.fair)
        normalLimit = Array(this.cpmStatsList?.length).fill(this.fileredWithKpi[0][0].normal)
        if (maxRange == 0) { badLimit = Array(this.cpmStatsList?.length).fill((2 * this.fileredWithKpi[0][0].normal) - this.fileredWithKpi[0][0].fair + 10) }  // NOSONAR
        else { badLimit = Array(this.cpmStatsList?.length).fill(maxRange - this.fileredWithKpi[0][0].fair + 10 + this.fileredWithKpi[0][0]?.normal) }
        this.lineChartData = {
          labels: this.lineChartLabels,
          datasets: [
            {
              data: badLimit,
              label: 'Normal',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            {
              data: fairLimit,
              label: 'Fair',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            {
              data: normalLimit,
              label: 'FAIR',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },

            {
              data: concernLimit,
              label: 'NG',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            // {
            //   data: graphData,
            //   label: this.selectedDomiciles.find(item => item.id == kpiIds.join('')).description,
            //   fill: false,
            //   pointRadius: 0,
            //   borderWidth: 2,
            //   tension: 0,
            //   backgroundColor: 'rgba(247, 82, 82,0.2)',
            //   borderColor: 'rgba(247, 82, 82,1)',
            // },
          ],
        };


      } else {
        this.callingLineChartColors()
        concernLimit = Array(this.cpmStatsList?.length).fill(this.fileredWithKpi[0][0]?.concern)
        fairLimit = Array(this.cpmStatsList?.length).fill(this.fileredWithKpi[0][0]?.fair)
        if (maxRange == 0) { badLimit = Array(this.cpmStatsList?.length).fill((2 * this.fileredWithKpi[0][0]?.concern) - this.fileredWithKpi[0][0]?.fair + 10) }  // NOSONAR
        else { badLimit = Array(this.cpmStatsList?.length).fill(maxRange - this.fileredWithKpi[0][0]?.fair + 10 + this.fileredWithKpi[0][0]?.concern) }

        this.lineChartData = {
          labels: this.lineChartLabels,
          datasets: [
            {
              data: badLimit,
              label: 'Normal',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            {
              data: fairLimit,
              label: 'Fair',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            {
              data: concernLimit,
              label: 'Concern',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            {
              data: badLimit,
              label: 'NG',
              fill: true,
              borderDash: [10, 3],
              pointRadius: 0,
              borderWidth: 2,

            },
            // {
            //   data: graphData,
            //   label: this.selectedDomiciles.find(item => item.id == kpiIds.join('')).description,
            //   fill: false,
            //   pointRadius: 0,
            //   borderWidth: 2,
            //   tension: 0,
            //   backgroundColor: 'rgba(247, 82, 82,0.2)',
            //   borderColor: 'rgba(247, 82, 82,1)',
            // },
          ],
        };

      }

      this.lineChartData.datasets.push({
        data: graphData,
        label: this.selectedDomiciles.find(item => item.id == kpiIds.join('')).description,   // NOSONAR
        fill: false,
        pointRadius: 0,
        tension: 0,
      });
      this.lineChartData.labels = this.lineChartLabels

      // } else {
      //   graphData = Array(this.cpmStatsList.length).fill(0)
      //   this.lineChartData.push({ data: graphData, label: kpiIds.join(''), fill: false, pointRadius: 0 })

      // }

    } else if (kpiIds.length > 1) {

      this.hideGraph = false;

      this.lineChartData = {
        labels: [],
        datasets: [], //  Ensure datasets is defined
      };
      this.fileredWithKpi = []
      this.fileredWithPlant = this.cpmthrosholdList?.filter(product => product.logisticsPoint == this.planName)  // NOSONAR
      kpiIds.forEach(element => {
        const graphData = this.cpmStatsList?.map(item => item[element])
        this.lineChartData.datasets.push({
          data: graphData,
          label: this.selectedDomiciles.find(item => item.id == element).description,  // NOSONAR
          fill: false,
          pointRadius: 0,
          borderWidth: 2,
          tension: 0
        });
        this.lineChartData.labels = this.lineChartLabels
        this.fileredWithKpi.push(this.fileredWithPlant?.filter(set => set.kpiCode == element))  // NOSONAR
        // } else {
        // graphData = Array(this.cpmStatsList.length).fill(0)
        // this.lineChartData.push({ data: graphData, label: element, fill: false, pointRadius: 0,borderWidth: 2 })

        // }
      })
    } else {

      this.hideGraph = true;

    }


  }

  callingLineChartColors() {
    this.lineChartColors = [
      { // Series A
        backgroundColor: this.brd_clr_5,
        borderColor: this.brdClr4,
        pointBackgroundColor: this.brdClr4,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr3
      },
      { // Series A
        backgroundColor: 'rgba(38, 136, 218, 0.2)',
        borderColor: this.const_brdrclr,
        pointBackgroundColor: this.const_brdrclr,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(38, 136, 218,0.8)'
      },
      { // Series B
        backgroundColor: 'rgba(250, 195, 57,0.2)',
        borderColor: this.brdClr2,
        pointBackgroundColor: this.brdClr2,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr2
      },
      { // Series B
        backgroundColor: 'rgba(247, 82, 82,0.2)',
        borderColor: this.brdClr1,
        pointBackgroundColor: this.brdClr1,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr1
      }
    ];
  }

  callingLineChartColorsforParking() {
    this.lineChartColors = [

      { // Series 4 - 
        backgroundColor: this.brd_clr_5,//green
        borderColor: this.brdClr4,
        pointBackgroundColor: this.brdClr4,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr3
      },
      { // Series 3 - 
        backgroundColor: 'rgba(38, 136, 218, 0.4)',//yellow - fair
        borderColor: this.const_brdrclr,
        pointBackgroundColor: this.const_brdrclr,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(38, 136, 218,0.8)'
      },
      { // Series 2 - 
        backgroundColor: 'rgba(250, 195, 57,0.3)', //orange - concern
        borderColor: this.brdClr2,
        pointBackgroundColor: this.brdClr2,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr2
      },
      { // Series 1 - 
        backgroundColor: 'rgba(247, 82, 82,0.7)', //red
        borderColor: this.brdClr1,
        pointBackgroundColor: this.brdClr1,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: this.brdClr1
      },
    ]
  }

  onLPchange() {
    this.refreshData()

  }

  onDatechange() {
    this.refreshData()
  }

  refreshData() {
    this.errorMessage = null;
    this.successMessage = null;
    this.statPlantList = []
    this.plantList.forEach(element => {
      if (this.domiciles.includes(element.position)) { this.statPlantList.push(element) }
    })

    //call the service here and initialise this.cpmStatsList and cpmthrosholdList   
    // in case of error or empty threshold list and empty stats list make hideGraph = true
    const lpDat = this.DatePipe.transform(this.lpDate, 'dd-MMM-yyyy');
    this.service.statsData(this.planName, lpDat)?.subscribe({
      next: (res: any) => {
        if (res.cpmStatsList.length > 0) {
          this.cpmStatsList = res.cpmStatsList
          this.cpmthrosholdList = res.cpmThresholdList
          this.onDomicileChange()
        } else { this.hideGraph = true }

      },
      error: (error) => {
        console.info(error);
      }
    })

  }

  auto() {
    this.autoPress = !this.autoPress;
    if (!this.autoPress) { this.stopLoop() }

    this.intervalSubscription = interval(this.selected_position_id)
      .pipe(takeWhile(() => this.componentIsActive()))
      .subscribe(() => {
        this.fetchCPMDashboardData();
      });
  }

  private componentIsActive(): boolean {
    // Add any condition here to determine if the component is still active
    if (this.autoPress) { return true; }
    return false;
  }

  stopLoop() {
    if (this.intervalSubscription) {
      this.intervalSubscription.unsubscribe();
    }
  }

  updateKpi() {
    const dialogRef = this.dialog.open(UpdateKpiComponent, {
      disableClose: true,
      width: '820px',
      height: '435px',
      data: {
        header: 'Update KPI',
        domicleList: this.plantList
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      if (result?.event == 'objectUpdated') {  // NOSONAR
        if (result?.eventType == 'success') {   // NOSONAR
          this.fetchCPMDashboardData()
          this.successMessage = 'KPI Updated';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 6000);
        } else {
          this.errorMessage = 'upadte KPI failed';
          setTimeout(() => {
            this.errorMessage = null;
            this.successMessage = null;
          }, 6000);
        }
      }
    });
  }

  updateCriteria() {
    const dialogRef = this.dialog.open(UpdateCriteriaComponent, {
      disableClose: true,
      width: '1010px',
      height: '435px',
      data: {
        header: 'Update Criteria',
        domicleList: this.plantList
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.errorMessage = null;
      this.successMessage = null;
      if (result?.event == 'success') {  // NOSONAR
        this.fetchCPMDashboardData()
        this.successMessage = "Criteria for the selected domicile is updated";
        setTimeout(() => {
          this.successMessage = null;
          this.errorMessage = null;
        }, 5000);
      }
    });
  }

  GetcolumnDef() {
    const plantValues = [
      'Last updated', 'Updated By', this.const_supp, this.const_act_drpd, this.const_drpd_rout, this.const_drpd,
      'Active Blowouts', 'Active Late Route', 'Active Shortage', 'Active Preemptive', this.constNamc, this.constExpd_covr,
      this.constExpd, this.constRoutes, this.const_plnd, this.constYard, 'Parking Spaces Occupied',
      'Yard Parking Available', this.constTotalContg, this.constTrailers, this.constContg,
      'Absenteeism', 'Misconnects', 'Daily Total Blowouts', 'Daily Total Late Route', 'Daily Total Shortage', 'Daily Total Preemptive'
    ]
    this.plantValues = plantValues

    this.columnDef = [
      {
        headerName: "DOMICILE", autoHeight: true, field: "name", minWidth: 170, maxWidth: 170,
        unSortIcon: true, sortable: false, pinned: 'left',
        cellRenderer: function (params) { const index = plantValues[params.node.rowIndex]; return `<span>${index}</span>` }
      }
    ]

    this.plantList.forEach(element => {
      if (this.domiciles?.includes(element.position)) {
        this.columnDef.push({
          headerName: element.description, autoHeight: true, field: element.description, minWidth: 120, //maxWidth: 120,
          unSortIcon: true, sortable: false,
          cellRenderer: function (params) { if (params.data.rowHeader != '') { return `<span>${params.data[element.description]}</span>` } else { return '' } }           // NOSONAR
        })
      }
    })
    this.columnDef.sort((a, b) => (a.headerName < b.headerName ? -1 : 1));
  }

  formatGridData(res: any) {
    const data: any = this.unwrapCpmResponse(res);
    const normalizedSnapshotList = this.normalizeSnapshotList(data?.snapshotList);
    if (normalizedSnapshotList.length > 0) {
      this.snapShotList = normalizedSnapshotList;
      if (!this.shapShotId || !this.snapShotList.some(x => x.position == this.shapShotId)) { // NOSONAR
        this.shapShotId = this.snapShotList[0].position;
      }
    }

    this.thresholdList = Array.isArray(data?.cpmThresholdList) ? data.cpmThresholdList : [];
    const cpmDataList = Array.isArray(data?.cpmDataList) ? data.cpmDataList : [];
    const rData: any = [];
    for (let i = 0; i < this.plantValues?.length; i++) {
      rData.push({ name: this.plantValues[i] });
    }
    for (let j = 0; j < cpmDataList.length; j++) {
      const val: any = {};
      for (let i = 0; i < rData.length; i++) {
        const element = cpmDataList[j];
        const planttemp = this.plantList.find(item => item.position == cpmDataList[j].logisticsPoint)?.description;  // NOSONAR

        rData[i][planttemp] = this.snapShotLoop(rData[i], element, cpmDataList[j].logisticsPoint);
      }
    }
    this.plantList.forEach(x => {
      for (let i = 0; i < rData.length; i++) {
        if (rData[i][x.description] == undefined) {  // NOSONAR
          rData[i][x.description] = '';
        }
      }
    });
    return rData;
  }

  private unwrapCpmResponse(res: any): any {
    if (!res) {
      return {};
    }
    return res?.event ?? res;
  }

  private normalizeSnapshotList(snapshotList: any): Array<{ position: any; description: string }> {
    if (!Array.isArray(snapshotList)) {
      return [];
    }

    return snapshotList
      .map((obj: any) => {
        const position = obj?.key ?? obj?.position ?? obj?.id ?? obj?.snapshotId ?? obj?.value;
        const rawDate = obj?.value ?? obj?.description ?? obj?.snapshotTime ?? obj?.snapshotDate ?? obj?.date;
        const description = this.dateFormatter(rawDate) ?? (rawDate ?? '')?.toString();
        if (!position && !description) {
          return null;
        }
        return { position, description };
      })
      .filter((x: any) => !!x);
  }

  getSnapshotsForDate() {
    this.errorMessage = null;
    this.successMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.snapShotList = [];
    const snapshotDate = this.DatePipe.transform(this.snapshotDate, 'dd-MMM-yyyy');
    this.service.getSnapshotsForDate(snapshotDate)?.subscribe({
      next: (res: any) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        const response = this.unwrapCpmResponse(res);
        const hasGridData = Array.isArray(response?.cpmDataList) && response.cpmDataList.length > 0;

        if (!hasGridData) {
          const normalizedSnapshotList = this.normalizeSnapshotList(response?.snapshotList);
          if (normalizedSnapshotList.length > 0) {
            this.snapShotList = normalizedSnapshotList;
            this.shapShotId = normalizedSnapshotList[0].position;
          }
          this.displayRowData = this.defaultDisplayRowData;
          if (this.shapShotId) {
            this.fetchCPMDashboardDataDropdown();
          }
        }
        else {
          const rData = this.formatGridData(response);
          this.displayRowData = rData;
          this.GetcolumnDef()
        }
        this.gridApi1.applyTransaction({ add: this.displayRowData });

      },
      error: (_error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);

        this.errorMessage = 'error';
      }
    })
  }



  getColorCodedBadge(value, logPtCode, kpiCode) {  // NOSONAR

    for (let i = 0; i < this.thresholdList.length; i++) {

      if (this.thresholdList[i].logisticsPoint == logPtCode && this.thresholdList[i].kpiCode == kpiCode) { // NOSONAR

        if (this.thresholdList[i].rangeOrder == 'INCREASING') {  // NOSONAR

          if (value > this.thresholdList[i].concern) {
            return '<span class="badge danger-bk white">' + value + '</span>';
          }
          else if (value > this.thresholdList[i].fair) {
            return '<span class="badge warning-bk white">' + value + '</span>';
          }
          else if (value > this.thresholdList[i].normal) {
            return '<span class="badge yellow-bk white">' + value + '</span>';
          }
          else {
            return '<span class="badge success-bk white">' + value + '</span>';
          }
        }
        else if (value > this.thresholdList[i].normal) {
          return '<span class="badge success-bk white">' + value + '</span>';
        }
        else if (value > this.thresholdList[i].fair) {
          return '<span class="badge yellow-bk white">' + value + '</span>';
        }
        else if (value > this.thresholdList[i].concern) {
          return '<span class="badge warning-bk white">' + value + '</span>';
        }
        else {
          return '<span class="badge danger-bk white">' + value + '</span>';
        }

      }
    }

    return value;
  }

  dateFormatter(res) {
    return res ? moment(res).format('MM/DD/YY HH:mm') : null;
  }

  getDelayedUpdateFlag(date) {

    let lastUpdate = date.substring(0, 10);
    const today = new Date();
    let newToday;
    newToday = this.DatePipe.transform(today, "MM-dd-yyyy");
    lastUpdate = Date.parse(lastUpdate);
    newToday = Date.parse(newToday);
    if (newToday > lastUpdate) {
      return `<img title="KPI not updated today!" src="assets/images/triangle-exclamation-solid.svg"/>`
    }
    else {
      return " "
    }

  }


  snapShotLoop(val, data, code: any = '') { // NOSONAR
    if (code == '50SER') {  // NOSONAR
      console.info('Val..............', val, data, code);
    }
    if (val.name == 'Last updated') {  // NOSONAR
      return (data.updatedDate ? this.dateFormatter(data.updatedDate) : null) + '&nbsp;&nbsp;' + this.getDelayedUpdateFlag(data.updatedDate);
    }

    else if (val.name == 'Updated By') {  // NOSONAR
      return data.updatedBy;
    }
    else if (val.name == this.const_supp) {  // NOSONAR
      return this.getColorCodedBadge(data.suppliersClosed, code, 'suppliersClosed');
    }
    else if (val.name == this.const_act_drpd) {  // NOSONAR
      return this.getColorCodedBadge(data.actualDroppedRoutes, code, 'actualDroppedRoutes');
    }
    else if (val.name == this.const_drpd_rout) {  // NOSONAR
      return this.getColorCodedBadge(data.droppedRoutes, code, 'droppedRoutes');
    }
    else if (val.name == this.const_drpd) {  // NOSONAR
      return this.getColorCodedBadge(data.droppedRoutesNotCovered, code, 'droppedRoutesNotCovered');
    }
    else if (val.name == 'Active Blowouts') {  // NOSONAR
      return this.getColorCodedBadge(data.blowout, code, 'blowout');
    }
    else if (val.name == this.constNamc) {  // NOSONAR
      return this.getColorCodedBadge(data.namcExpedites, code, 'namcExpedites');
    }
    else if (val.name == this.constExpd_covr) {  // NOSONAR
      return this.getColorCodedBadge(data.recoveryExpedites, code, 'recoveryExpedites');
    }
    else if (val.name == this.constExpd) {  // NOSONAR
      return this.getColorCodedBadge(data.expeditesNotCovered, code, 'expeditesNotCovered');
    }
    else if (val.name == this.constRoutes) {  // NOSONAR
      return this.getColorCodedBadge(data.routesMissedUnload, code, 'routesMissedUnload');
    }
    else if (val.name == this.const_plnd) {  // NOSONAR
      return this.getColorCodedBadge(data.plannedMissedUnload, code, 'plannedMissedUnload');
    }
    else if (val.name == 'Yard Parking Available') {  // NOSONAR
      return this.getColorCodedBadge(data.parkingAvailable, code, 'parkingAvailable');
    }
    else if (val.name == this.constContg) {  // NOSONAR
      return this.getColorCodedBadge(data.cntgntTrailersAvailable, code, 'cntgntTrailersAvailable');
    }
    else if (val.name == 'Absenteeism') {  // NOSONAR
      return this.getColorCodedBadge(data.absenteeism, code, 'absenteeism');
    }
    else if (val.name == 'Active Late Route') {  // NOSONAR
      return this.getColorCodedBadge(data.lateRoute, code, 'activeLateRoute');
    }
    else if (val.name == 'Active Shortage') {  // NOSONAR
      return this.getColorCodedBadge(data.shortage, code, 'activeShortage');
    }
    else if (val.name == 'Active Preemptive') {  // NOSONAR
      return this.getColorCodedBadge(data.preemptive, code, 'activePreemptive');
    }
    else if (val.name == this.constYard) {  // NOSONAR
      return this.getColorCodedBadge(data.ydParkingCapacity, code, 'yardParkingCapacity');
    }
    else if (val.name == 'Parking Spaces Occupied') {  // NOSONAR
      return this.getColorCodedBadge(data.parkingOccupied, code, 'parkingSpacesOccupied');
    }
    else if (val.name == this.constTotalContg) {  // NOSONAR
      return this.getColorCodedBadge(data.cntgntTrailers, code, 'totalContingentTrailers');
    }
    else if (val.name == this.constTrailers) {  // NOSONAR
      return this.getColorCodedBadge(data.cntgntTrailersInUse, code, 'contingentTrailersInUse');
    }
    else if (val.name == 'Daily Total Blowouts') {  // NOSONAR
      return this.getColorCodedBadge(data.totalBlowout, code, 'dailyTotalBlowouts');
    }
    else if (val.name == 'Daily Total Late Route') {  // NOSONAR
      return this.getColorCodedBadge(data.totalLateRoute, code, 'dailyTotalLateRoute');
    }
    else if (val.name == 'Daily Total Shortage') {  // NOSONAR
      return this.getColorCodedBadge(data.totalShortage, code, 'dailyTotalShortage');
    }
    else if (val.name == 'Daily Total Preemptive') {  // NOSONAR
      return this.getColorCodedBadge(data.totalPreemptive, code, 'dailyTotalPreemptive');
    }
    else if (val.name == 'Misconnects') {  // NOSONAR
      return this.getColorCodedBadge(data.misconnects, code, 'misconnects');
    }
    else
     { return null }
  }

  fetchCPMDashboardData() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.service.fetchCPMDashboardData()?.subscribe({
      next: (res: any) => {
        const response = this.unwrapCpmResponse(res);
        this.snapShotList = this.normalizeSnapshotList(response?.snapshotList);
        if (this.highlightUnVerified) {
          this.domiciles = []
          this.domiciles = response.cpmDataList?.map(item => item.logisticsPoint)
          this.displayCurrentData = this.formatGridData(response);
          this.GetcolumnDef()
          this.gridApi2.applyTransaction({ add: this.displayRowData });
          this.rowCount = this.displayCurrentData.length;
        }
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(error);
        this.errorMessage = 'error';
      }
    })
    this.Current();
  }

  fetchCPMDashboardDataDropdown() {
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.service.fetchCPMDashboardDataDropdown(this.shapShotId).subscribe({
      next: (res) => {
        if (this.highlightVerified) {
          const response = this.unwrapCpmResponse(res);
          this.displayRowData = this.formatGridData(response);
          this.GetcolumnDef()
          this.gridApi1.applyTransaction({ add: this.displayRowData });
          this.rowCountHistory = this.displayRowData.length;
        }
        this.ngxUiLoaderService.stop(CommonConstant.loader);
      },
      error: (error) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        console.info(error);
      },
    });
  }

  sizeToFit1() {
    this.gridApi1?.sizeColumnsToFit();
  }

  sizeToFit2() {
    this.gridApi2?.sizeColumnsToFit();
  }

  onGridReady1(params: any) {
    this.gridApi1 = params.api
    this.gridApi1.sizeColumnsToFit();
  }

  onGridReady2(params: any) {
    this.gridApi2 = params.api
    this.gridApi2.sizeColumnsToFit();
  }

  Current() {
    this.highlightTrailer = false
    this.highlightUnVerified = true
    this.highlightVerified = false
    this.selectedTab = 'current'
  }


  History() {
    this.highlightTrailer = false
    this.highlightUnVerified = false
    this.highlightVerified = true
    this.selectedTab = 'history'
    const date = new Date();
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    this.snapshotDate = formattedDate
    this.autoPress = false;
    this.getSnapshotsForDate();
  }


  Statistics() {
    this.highlightTrailer = true
    this.highlightUnVerified = false
    this.highlightVerified = false
    this.selectedTab = 'statistics'
    const date = new Date(this.pastDate);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    const formattedDate = `${year}-${month}-${day}`;
    this.lpDate = formattedDate
    this.autoPress = false;
    this.optionalDomiciles = [{ id: 'suppliersClosed', description: this.const_supp }];
    this.refreshData()
  }
  compareById(o1: any, o2: any): boolean {
    return o1 && o2 ? o1.id == o2.id : o1 == o2;  // NOSONAR
  }
  onBtExport() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.service.exportCPMDashboard()
      .subscribe({
        next: (response) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          const filename = "ControlPoint_Dashboard"
          const data: Blob = new Blob([(<any>response)?.body], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(data, filename);
        },
        error: () => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.downloadError;
        }
      })
  }

  viewComments() {
    this.service.fetchCPMComments(20).subscribe({
      next: (res) => {

        const dialogRef = this.dialog.open(ViewCommentsComponent, {
          disableClose: true,
          width: '800px',
          height: '435px',
          data: {
            header: 'Displaying Comments For Last 20 Days',
            result: res
          }

        });
        console.info(dialogRef)
      }
    })
  }

}